/**
 * Firebase Configuration for Web Push Notifications
 *
 * This file initializes Firebase and exports the messaging instance
 * for use throughout the application.
 */

import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

// Firebase config - HARDCODED for reliable initialization
// (matches service worker config for consistency)
const firebaseConfig = {
    apiKey: "AIzaSyAR1SGjhq_wuETY5lXu2VY6r9x9vvBELHE",
    authDomain: "task-logger-481513.firebaseapp.com",
    projectId: "task-logger-481513",
    storageBucket: "task-logger-481513.firebasestorage.app",
    messagingSenderId: "29784058088",
    appId: "1:29784058088:web:2a25d929ba157bec70815d"
};

// Initialize Firebase only if not already initialized
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Messaging instance (initialized lazily)
let messaging = null;

/**
 * Get Firebase Messaging instance
 * Returns null if messaging is not supported (e.g., in unsupported browsers)
 */
export const getFirebaseMessaging = async () => {
    if (messaging) return messaging;

    try {
        const supported = await isSupported();
        if (supported) {
            messaging = getMessaging(app);
            return messaging;
        }
        console.warn('Firebase Messaging is not supported in this browser');
        return null;
    } catch (error) {
        console.error('Error initializing Firebase Messaging:', error);
        return null;
    }
};

export { app };
export default app;

